import * as types from "./types";

export const CategoryInitialState = {
  //get request for all role
  allCategory: <any>[],
  allCategoryLoading: false,
  allCategoryError: null,

  // post request
  postCategoryLoading: false,
  postCategoryError: null,

  //get single category
  getSingleCategoryLoading:false,
  singleCategory:null,
  getSingleCategoryError:null,

  // delete and restore category
  delResLoading:false


};


export const categoryReducer = (state = CategoryInitialState, action: any) => {
  switch (action.type) {
    case types.POST_CATEGORY_FETCH_START:
      return {
        ...state,
        postCategoryLoading: true,
      };
    case types.POST_CATEGORY_FETCH_SUCCESS:
      return {
        ...state,
        postCategoryLoading: false,
      };
    case types.POST_CATEGORY_FETCH_FAILURE:
      return {
        ...state,
        postCategoryError: action.postCategoryError,
        postCategoryLoading: false,
      };

    case types.ALL_CATEGORY_GET_START:
      return {
        ...state,
        allCategoryLoading: true,
      };
    case types.ALL_CATEGORY_GET_SUCCESS:
      return {
        ...state,
        allCategory: action.allCategory,
        allCategoryLoading: false,
      };
    case types.ALL_CATEGORY_GET_FAILURE:
      return {
        ...state,
        allCategoryError: action.allCategoryError,
        allCategoryLoading: false,
      };
    case types.GET_SINGLE_CATEGORY_START:
      return{
        ...state,
        getSingleCategoryLoading:true,
        singleCategory:null
      }
    case types.GET_SINGLE_CATEGORY_SUCCESS:
      return{
        ...state,
        getSingleCategoryLoading:true,
        singleCategory:action.singleCategory
      }
    case types.GET_SINGLE_CATEGORY_FAILURE:
      return{
        ...state,
        getSingleCategoryError:action.getSingleCategoryError
      }
    
    case types.DEL_RES_CATEGORY_START:
      return{
        ...state,
        delResLoading:true
      }
    case types.DEL_RES_CATEGORY_SUCCESS:
      return{
        ...state,
        delResLoading:false
      }
    case types.DEL_RES_CATEGORY_FAILURE:
      return{
        ...state,
        delResLoading:false
      }

    default:
      return state;
  }
};
